// @internal
import './number-operations';

let actionlock: any;

function getCurrentTimestamp()
{
	return new Date().getTime();
}

function getValue(list: any, key: string)
{
	if (list)
	{
		return list[key];
	}
	else
	{
		return undefined;
	}
}

function setValue(list: any, key: string, value: any)
{
	if (!list)
	{
		list = {};
	}

	list[key] = value;

	return list;
}

function clearValue(list: any, key: string)
{
	if (list)
	{
		delete list[key];
	}

	let found = false;
	for (let a in list)
	{
		found = true;
		break;
	}

	if (!found)
	{
		list = null;
	}

	return list;
}

/* ActionLock*/
function hasLock(lockName: string)
{
	if (actionlock && actionlock[lockName])
	{
		let ret = getValue(actionlock, lockName) && getValue(actionlock, lockName) > getCurrentTimestamp();

		if (!ret)
		{
			actionlock = clearValue(actionlock, lockName);
		}

		return ret;
	}
	else
	{
		return false;
	}
}

export function actionLock(lockName: string, delayInMillis: number): boolean
{
	if (hasLock(lockName))
	{
		return false;
	}
	else
	{
		if (delayInMillis > 0)
		{
			actionlock = setValue(actionlock, lockName, getCurrentTimestamp() + delayInMillis);
		}

		return true;
	}
}

let counters: any;
let locked: any;

export function lastActionHero(this: any, lockName: string, callback: Function, atomic: boolean | undefined, delayInMillis: number | undefined): void
{
	if (delayInMillis === undefined)
	{
		delayInMillis = 250;
	}
	if (atomic === undefined)
	{
		atomic = true;
	}

	let c = window.parseIntSafe(getValue(counters, lockName), undefined) + 1;

	counters = setValue(counters, lockName, c);

	setTimeout(() =>
	{
		if (c == getValue(counters, lockName))
		{
			if (atomic && getValue(locked, lockName) === true)
			{
				lastActionHero(lockName, callback, atomic, delayInMillis);
			}
			else
			{
				if (atomic)
				{
					locked = setValue(locked, lockName, true);
				}

				callback.call(this, () =>
				{
					if (atomic)
					{
						locked = clearValue(locked, lockName);
					}

					if ((atomic || c == getValue(counters, lockName)) && c > 1024)
					{
						counters = clearValue(counters, lockName);
					}
				});
			}
		}
	}, delayInMillis);
}

export function wrapLastActionHero(thisObj: any, lockName: string, callback: Function, atomic: boolean | undefined, delayInMillis: number | undefined): Function
{
	return lastActionHero.bind(thisObj, lockName, callback, atomic, delayInMillis);
}
